import type { IdeationCardProps } from './IdeationCard.types';
import { useTranslation } from 'react-i18next';

export const IdeationCard = ({ idea, index }: IdeationCardProps): React.JSX.Element => {
  const { t } = useTranslation('analysis');

  return (
    <div className="flex flex-col gap-3 p-6 h-full rounded-lg bg-accent">
      {/* Header with Index */}
      <div className="flex gap-3">
        <div className="rounded-sm w-8 h-8 flex items-center justify-center bg-primary">
          <p className="text-sm text-primary-foreground">{index + 1}</p>
        </div>
        {/* Title */}
        <p className="text-base font-medium text-primary mt-1">{idea.title}</p>
      </div>

      {/* Description */}
      <p className="text-base text-foreground-alt">{idea.description}</p>

      {/* Provocation */}
      {idea.provocation && (
        <div className="bg-card rounded-lg p-4">
          <div className="flex flex-col gap-1 items-start">
            <p className="mb-0.5 text-sm font-medium text-foreground">
              {t('socialMediaOpportunitiesWidget.ideationCard.provocation')}
            </p>
            <p className="text-sm text-foreground-alt">{idea.provocation}</p>
          </div>
        </div>
      )}
    </div>
  );
};
